import * as ol_geom from "ol/geom"
import * as ol_layer from "ol/layer"
import * as ol_style from "ol/style"
import * as ol_extent from "ol/extent"
import * as ol_format from "ol/format"
import * as ol_render from "ol/render/Feature"
import * as ol_source from "ol/source"
import * as ol_interaction from "ol/interaction"
import * as ol_events from "ol/events"
import * as ol_events_condition from "ol/events/condition"
import * as ol_control from "ol/control"
import { Type as GeometryType } from "ol/geom/Geometry"
import { Feature, MapBrowserEvent } from "ol"
import { fromCircle as ol_polygonFromCircle } from "ol/geom/Polygon"
import VectorSource from "ol/source/Vector"
import ol_LayerBase from "ol/layer/Base"
import ImageSource from "ol/source/Image"
import { Coordinate } from "ol/coordinate"
import RenderFeature from "ol/render/Feature"
import Map from "ol/Map"
import View from "ol/View"
import * as ol_proj from "ol/proj"
import { Overlay, Collection, Observable } from "ol"
import { unByKey as ol_Observable_unByKey } from "ol/Observable"
import { Color } from "ol/color"
import { Pixel } from "ol/pixel"

import type { FeatureLike } from "ol/Feature"

export type ol_MapBrowserPointerEvent = MapBrowserEvent<UIEvent>
export type ol_MapBrowserEvent = MapBrowserEvent<UIEvent>

export type ol_Extent = ol_extent.Extent

export const ol_Feature = Feature
export type ol_Feature = Feature

export type ol_Map = Map
export const ol_Map = Map

export type ol_View = View
export const ol_View = View

export type ol_Overlay = Overlay
export const ol_Overlay = Overlay

export type ol_Observable = Observable

export type ol_Coordinate = Coordinate

export type ol_GeometryType = GeometryType

export type ol_render_Feature = RenderFeature
export type ol_FeatureLike = FeatureLike

export type ol_Collection<T> = Collection<T>
export const ol_Collection = Collection

export type ol_Color = Color
export type ol_Pixel = Pixel

export {
    ol_LayerBase,
    ol_geom,
    ol_layer,
    ol_style,
    ol_extent,
    ol_format,
    ol_render,
    ol_source,
    ol_proj,
    ol_events,
    ol_events_condition,
    ol_interaction,
    ol_control,
    ol_Observable_unByKey,
    ol_polygonFromCircle
}


export type ol_VectorLayer = ol_layer.Vector
export type ol_ImageLayer = ol_layer.Image<ImageSource>
